// Production build - API URL is baked in via REACT_APP_API_URL at build time (see CI workflow).
import { PROD_API_URL } from '../apiConfig';

// Track last API call time for cold start prevention
let lastApiCallTime = Date.now();
const INACTIVITY_THRESHOLD_MS = 15 * 60 * 1000; // 15 minutes

const getApiUrl = () => {
  return process.env.NODE_ENV === 'development'
    ? ''
    : (process.env.REACT_APP_API_URL || (window.location.protocol + "//" + window.location.hostname + ":59443"));
};

// Warm up the Cloud Run backend to avoid cold start delays
export const warmUpBackend = async () => {
  const apiUrl = PROD_API_URL;
  try {
    const response = await fetch(apiUrl + '/', {
      method: 'GET',
      headers: { 'accept': 'application/json' }
    });
    if (response.ok) {
      console.log('Backend warmed up successfully');
      return true;
    }
  } catch (error) {
    console.log('Backend warm-up request sent (may still be starting)');
  }
  return false;
};

// Check if we need to warm up due to inactivity
const warmUpIfNeeded = async () => {
  const timeSinceLastCall = Date.now() - lastApiCallTime;
  if (timeSinceLastCall > INACTIVITY_THRESHOLD_MS) {
    console.log(`Inactivity detected (${Math.round(timeSinceLastCall / 60000)} min), warming up backend...`);
    await warmUpBackend();
  }
};

export const postRequest = async (endpoint, jsonData, convertToJson = true) => {
    // Warm up backend if inactive for 15+ minutes
    await warmUpIfNeeded();

    const currentUrl = getApiUrl();
    const rawResponse = await fetch(currentUrl + '/'+ endpoint,{
      method: 'POST',
      url: currentUrl,
      headers: {
        'accept': 'application/json',
        'content-Type': 'application/json'
      },
      body: jsonData
    });

    // Update last call time after successful request
    lastApiCallTime = Date.now();

    if (!rawResponse.ok) {
      const errorText = await rawResponse.text();
      throw new Error(`API error (${rawResponse.status}): ${errorText}`);
    }

    if(convertToJson === true){
      return await rawResponse.json();
    }
    return await rawResponse;
}

export const getRequestNoParams = async (endpoint, convertToJson = true) => {
  // Warm up backend if inactive for 15+ minutes
  await warmUpIfNeeded();

  const currentUrl = getApiUrl();
  const rawResponse = await fetch(currentUrl + '/'+ endpoint,{
    method: 'GET',
    url: currentUrl,
    headers: {
      'accept': 'application/json',
      'content-Type': 'application/json'
    }
  });

  // Update last call time after successful request
  lastApiCallTime = Date.now();

  if(convertToJson === true){
    return await rawResponse.json();
  }
  return await rawResponse;
}
